export const API_BASE = process.env.REACT_APP_API_BASE;
export const OAUTH_URL = process.env.REACT_APP_OAUTH_URL;
export const OAUTH_CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID;
export const OAUTH_REDIRECT_PATH = process.env.REACT_APP_OAUTH_REDIRECT_PATH;
